export class FileToUpload {
  fileName: string;
  fileSize: number;
  fileType: string;
  lastModifiedTime: number;
  lastModifiedDate: Date;
  fileAsBase64: string;
  //length: number;
}
